import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { actions as dashboardActions } from '@store/ducks/dashboard';
import useDashboardExport from '@hooks/useDashboardExport';

// Partials
import ChartHeader from './ChartHeader';
import Chart from './Chart';

// Components
import { Title, Box } from '@components';

// Style
import { ChartContainer } from './../Styled';

// UTILS
import { getPreviousDate, getDateNowServer } from '@utils';

const ChartAccessFrequency = () => {
  const [filterDatePreviousDay, setFilterDatePreviousDay] = useState(7);
  const [filterGroups, setFilterGroups] = useState([]);
  const { exportChartAccesses } = useDashboardExport();

  const getFilterDate = (number) => setFilterDatePreviousDay(number);
  const getFilterGroups = (str) => setFilterGroups(str);
  const dispatch = useDispatch();

  const getExportParams = () => ({
    date_start: getPreviousDate(filterDatePreviousDay),
    date_end: getDateNowServer(),
    groups: filterGroups,
  });

  const handleExport = () => exportChartAccesses(getExportParams());

  const handleFilters = () => {
    const date_start = getPreviousDate(filterDatePreviousDay);
    const date_end = getDateNowServer();
    const groups = filterGroups;
    const params = {
      date_start,
      date_end,
      groups,
    };

    dispatch(dashboardActions.getGraphicAccessFrequencyRequest({ params }));
  };

  useEffect(() => {
    if (filterDatePreviousDay || filterGroups) handleFilters();
  }, [filterDatePreviousDay, filterGroups]);

  return (
    <>
      <Title
        title="Frequência de acesso"
        subtitle="Veja a quantidade de logins realizados por dia, você poderá consultar essa informação por período de tempo ou grupos."
      />
      <Box>
        <ChartContainer>
          <ChartHeader
            getFilterDate={getFilterDate}
            getFilterGroups={getFilterGroups}
            filterDateKey="graphicAccessFrequency"
            filterGroupsKey="graphicAccessFrequency"
            onDownload={handleExport}
          />
          <Chart />
        </ChartContainer>
      </Box>
    </>
  );
};

export default ChartAccessFrequency;
export { ChartAccessFrequency };
